import React from 'react';
const facts = [{
  value: '52',
  label: 'Weeks mapped, in order'
}, {
  value: '300',
  label: 'Pages of counted blocks'
}, {
  value: '30/45/55',
  label: 'Minute versions of every class'
}, {
  value: '16',
  label: 'Planning worksheets'
}];
export function SocialProofBar() {
  return <section className="w-full bg-plum-deep" data-id="element-251" data-mp="25t40j49m86ro">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-252" data-mp="25uf5h7esrkkd">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-plum-line bg-plum-line sm:grid-cols-4" data-id="element-253" data-mp="32jmn44cap9j0">
          {facts.map(fact => <div key={fact.label} className="bg-plum px-4 py-5 text-center" data-id="element-254" data-mp="2xi774qoz5t7h">
              <div className="font-display font-semibold text-3xl sm:text-4xl leading-none text-gold" data-id="element-255" data-mp="2tglm2i2ae8m7">
                {fact.value}
              </div>
              <div className="mt-2 text-[10px] font-semibold uppercase tracking-widest text-white/60" data-id="element-256" data-mp="1i3sy7icma4bf">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}